/** @jsxImportSource @emotion/react */
import React from 'react';

import { IProductWidget } from '@ddot/AddToCartCommon/lib/entities';
import { Container, Col, Row } from 'reactstrap';
import { css } from '@emotion/react';

import Fonts from 'Themes/fonts';
import Colors from 'Themes/colors';

import FeaturedProduct from './FeaturedProduct';

interface WidgetProps {
    widget: IProductWidget;
}

const ProductWidget = (props: WidgetProps): JSX.Element | null => {
    const { widget } = props;
    const { title, description, products } = widget;

    if (!widget) return null;

    const renderProducts = () => {
        return products.map(item => (
            <Col xs={6} sm={4} md={3} lg={2} key={item.id} className='p-0'>
                <FeaturedProduct product={item} type='list' />
            </Col>
        ));
    };

    return (
        <Container fluid css={styles.container}>
            {/* <div css={styles.title}>{title}</div> */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 css={styles.title}>New Arrivals</h2>
                <a href='/categories'><p style={{ color: '#064E72', textDecoration: 'underline', fontSize: '1.5rem', fontFamily: 'AcuminRPro', margin: 0 }}>View More</p></a>
            </div>
            <Row xs={1} sm={4} md={5} css={styles.productListWrapper}>
                {renderProducts()}
            </Row>
        </Container>
    );
};

const styles = {
    container: css({
        '@media(min-width: 300px)': {
            backgroundColor: Colors.white,
            border: '1px',
            borderWidth: 1,
            borderColor: Colors.border,
            textAlign: 'center',
            marginTop: 10,
        },

        '@media(min-width:992px)': {
            paddingLeft: 0,
            paddingRight: 0,
        },

        '@media(min-width: 1200px)': {
            backgroundColor: Colors.white,
            border: '1px',
            borderWidth: 1,
            borderColor: Colors.border,
            textAlign: 'center',
            marginTop: 10,
        },
    }),
    title: css({
        '@media(min-width: 300px)': {
            fontWeight: 'bold',
            fontSize: '4rem',
            letterSpacing: 2,
            transform: 'scale(1, 0.9)',
            margin: 0,
        },
        '@media(min-width: 1200px)': {
            fontWeight: 'bold',
            fontSize: '4rem',
            letterSpacing: 2,
            transform: 'scale(1, 0.9)',
            margin: 0,
        },

    }),

    productListWrapper: css({
        marginTop: 20,

        '@media(min-width: 1200px)': {
            paddingLeft: 50,
            paddingRight: 50,
        },
    }),
};

export default ProductWidget;
